/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutTaskNotificationPhase } from './rolloutTaskNotificationPhase';
import { RolloutType } from './rolloutType';
import { ScheduledNotificationBefore } from './scheduledNotificationBefore';


export interface RolloutNotificationConfigPatchRequest { 
    /**
     * Whether the notification is enabled.
     */
    enabled?: boolean;
    rollout_type?: RolloutType;
    phase?: RolloutTaskNotificationPhase;
    /**
     * List of triggers for the notification if applicable.
     */
    triggers?: Array<ScheduledNotificationBefore>;
}
export namespace RolloutNotificationConfigPatchRequest {
}


